import { id, root } from './configs';
import { list } from './list';

export const configs = { ...root, id, list };
